import { __extends } from "tslib";
import { MethodBase, _Shader_MethodBase } from "./MethodBase";
/**
 * NormalBasicMethod is the default method for standard tangent-space normal mapping.
 */
var NormalBasicMethod = /** @class */ (function (_super) {
    __extends(NormalBasicMethod, _super);
    /**
     * Creates a new NormalBasicMethod object.
     */
    function NormalBasicMethod(texture) {
        if (texture === void 0) { texture = null; }
        var _this = _super.call(this) || this;
        _this._texture = texture;
        if (_this._texture)
            _this.iAddTexture(_this._texture);
        return _this;
    }
    Object.defineProperty(NormalBasicMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return NormalBasicMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(NormalBasicMethod.prototype, "texture", {
        /**
         * A texture to modulate the direction of the surface for each texel (normal map). The default normal method expects
         * tangent-space normal maps, but others could expect object-space maps.
         */
        get: function () {
            return this._texture;
        },
        set: function (value) {
            if (this._texture == value)
                return;
            if (this._texture)
                this.iRemoveTexture(this._texture);
            this._texture = value;
            if (this._texture)
                this.iAddTexture(this._texture);
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @inheritDoc
     */
    NormalBasicMethod.prototype.copyFrom = function (method) {
        var s = method;
        var bnm = method;
        if (bnm.texture != null)
            this.texture = bnm.texture;
    };
    /**
     * @inheritDoc
     */
    NormalBasicMethod.prototype.dispose = function () {
        if (this._texture)
            this._texture = null;
    };
    NormalBasicMethod.assetType = "[asset NormalBasicMethod]";
    return NormalBasicMethod;
}(MethodBase));
export { NormalBasicMethod };
import { ShaderBase } from "@awayjs/renderer";
/**
 * _Shader_NormalBasicMethod is the default method for standard tangent-space normal mapping.
 */
var _Shader_NormalBasicMethod = /** @class */ (function (_super) {
    __extends(_Shader_NormalBasicMethod, _super);
    /**
     * Creates a new EffectEnvMapChunk.
     */
    function _Shader_NormalBasicMethod(method, shader) {
        var _this = _super.call(this, method, shader) || this;
        _this._method = method;
        _this._shader = shader;
        return _this;
    }
    _Shader_NormalBasicMethod.prototype._isUsed = function () {
        if (this._texture && this._shader.normalDependencies)
            return true;
        return false;
    };
    /**
     * @inheritDoc
     */
    _Shader_NormalBasicMethod.prototype._initVO = function (chunkVO) {
        if (this._method.texture) {
            this._texture = this._shader.getAbstraction(this._method.texture);
            this._texture._initVO(chunkVO);
            this._shader.uvDependencies++;
        }
    };
    /**
     * @inheritDoc
     */
    _Shader_NormalBasicMethod.prototype._initConstants = function () {
        if (this._method.texture)
            this._texture._initConstants();
    };
    /**
     * Indicates whether or not this method outputs normals in tangent space. Override for object-space normals.
     */
    _Shader_NormalBasicMethod.prototype._outputsTangentNormals = function () {
        return true;
    };
    /**
     * @inheritDoc
     */
    _Shader_NormalBasicMethod.prototype._activate = function () {
        if (this._texture)
            this._texture.activate();
    };
    _Shader_NormalBasicMethod.prototype._setRenderState = function (renderState) {
        if (this._texture)
            this._texture._setRenderState(renderState);
    };
    /**
     * @inheritDoc
     */
    _Shader_NormalBasicMethod.prototype._getFragmentCode = function (targetReg, registerCache, sharedRegisters) {
        var code = "";
        if (this._texture)
            code += this._texture._getFragmentCode(targetReg, registerCache, sharedRegisters, sharedRegisters.uvVarying);
        code += "sub " + targetReg + ".xyz, " + targetReg + ".xyz, " + sharedRegisters.commons + ".xxx\n" +
            "nrm " + targetReg + ".xyz, " + targetReg + "\n";
        return code;
    };
    return _Shader_NormalBasicMethod;
}(_Shader_MethodBase));
export { _Shader_NormalBasicMethod };
ShaderBase.registerAbstraction(_Shader_NormalBasicMethod, NormalBasicMethod);
